<template>
  <div class="app-main-content">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <fcl-search-bar
        :show-currency="false"
        :is-manage-module="true"
        :show-schedule="false"
        :filter="filter"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemResetCallBack="toAdvancedQuery"
      >
        <template v-if="activeTabName === 'cpList'" slot="operations">
          <el-button v-show="inputAllowed_PP" no="onEditCP" type="primary" :disabled="!this.cpSelectRow" @click="onEdit_CP()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button v-show="deleteAllowed_CP" no="onDeleteCP" type="danger" @click="onDelete_CP()">{{ $t('Pricing.Delete') }}</el-button>
        </template>
        <template v-if="activeTabName !== 'cpList'" slot="operations">
          <el-button v-show="inputAllowed_PP" no="onEditPP" type="primary" :disabled="!this.ppSelectRow" @click="onEdit_PP()">{{ $t('Pricing.Edit') }}</el-button>
          <el-button no="onDeletePP" type="danger" @click="onDelete_PP()">{{ $t('Pricing.Delete') }}</el-button>
          <el-button v-show="approveAllowed_PP" no="onApprovePP" type="primary" @click="onApprove_PP()">{{ $t('Pricing.Approve') }}</el-button>
          <el-button v-show="inputAllowed_PP" no="onAddPP" type="primary" @click="onAdd_PP()">{{ $t('Pricing.Add') }}</el-button>
          <el-button v-show="inputAllowed_PP" no="onDownloadTemplate" type="primary" @click="onDownloadTemplate()">{{ $t('Pricing.Template') }}</el-button>
          <el-upload
            v-show="inputAllowed_PP"
            no="onEditCP"
            :action="URL.price.priceWeightLimit.saveExcelFile"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :on-success="uploadExcelSuccess"
            :data="{currentOfficeId:$store.getters.currentOfficeId}"
            style="display: inline-block; margin-left: 5px"
          >
            <el-button no="import" type="primary">{{ $t('Pricing.Import') }}</el-button>
          </el-upload>
        </template>
      </fcl-search-bar>
    </div>
    <div class="tabs-container">
      <el-tabs
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleTabClick"
      >
        <el-tab-pane :label="$t('Pricing.CurrentPrice')" name="cpList">
          <weight-limit-data-grid
            config-module="221001"
            :row-data="rowCpData"
            :show-approve="true"
            :show-create="true"
            :show-modify="true"
            :filter="filter"
            :grid-options="cpGridOptions"
            @selectRowChange="selectRowChange"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('Pricing.PendingPrice')" name="ppList">
          <weight-limit-data-grid
            config-module="221002"
            :row-data="rowPpData"
            :show-create="true"
            :show-modify="true"
            :show-selection="true"
            :filter="filter"
            :grid-options="ppGridOptions"
            @selectRowChange="selectRowChange"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <weight-limit-form
      v-if="weightLimitFormDialog.visible"
      :visible="weightLimitFormDialog.visible"
      :price="weightLimitFormDialog.price"
      :is-new="weightLimitFormDialog.isNew"
      @close="onWeightLimitFormDialogClose"
      @reload="toQuery"
    />
  </div>
</template>

<script>

import FclSearchBar from '@/views/cargo/v0/Price/components/query/fclSearchBar'
import { getLoading } from '@/utils/utilBaseElement'
import DateUtils from '@/utils/dateUtils'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
import { PricingFCLConfigUtil } from '@/class/cargo/model/utils/PricingFCLConfigUtil'
import StrUtils from '@/utils/StrUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'
import { PriceUploadExceptionUtil } from '@/class/cargo/model/utils/PriceUploadExceptionUtil'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import LocalStorageUtils from '@/utils/localStorageUtils'
import WeightLimitDataGrid from '@/views/cargo/v0/Price/components/grid/weightLimitDataGrid'
import {
  approvePriceWeightLimits,
  deletePriceWeightLimits,
  queryEffectivePriceWeightLimit,
  queryPendingPriceWeightLimit
} from '@/api/price/priceWeightLimit'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import WeightLimitForm from '@/views/cargo/v0/Price/PriceWeightLimit/components/weightLimitForm'

export default {
  name: 'PriceWeightLimit',
  components: {
    WeightLimitForm,
    WeightLimitDataGrid,
    FclSearchBar },
  data() {
    return {
      URL,
      activeTabName: 'ppList',
      isHQManager: false,
      remarkChange: '',
      targetLevel: 99,
      txtRemarks: '',
      showLevel: false,
      showDetail: false,
      fullscreenLoading: null,
      proxy: {},
      filter: {
        total: 0,
        pol: '',
        pols: '',
        pods: '',
        pod: '',
        cod: '',
        col: '',
        rod: '',
        rol: '',
        carrier: [],
        region: '',
        polCityCode: '',
        podCityCode: '',
        cmbCreatedBy: 'createdBy',
        createdBy: 0,
        branch: 0,
        saleState: -1,
        txtBookingAgent: '',
        unNo: '',
        contractNo: '',
        level: '',
        currency: '',
        beginDate: null,
        endDate: '',
        createDateFrom: DateUtils.formatStandardDate(new Date()),
        dangerous: false,
        simPol: '',
        simPod: ''
      },
      rowCpData: [],
      rowPpData: [],
      cpGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      ppGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      weightLimitFormDialog: {
        visible: false,
        price: {},
        isNew: false
      },
      cpSelectRow: null, // 已发布的单击选择行
      ppSelectRow: null, // 待审核的单击选择行
      approveAllowed_PP: false,
      deleteAllowed_PP: false,
      deleteAllowed_CP: false,
      inputAllowed_PP: false,
      priceFclUtil: null
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    sessionId() {
      return this.$store.getters.token
    },
    isActiveCpTab() {
      return this.activeTabName === 'cpList'
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.init()
    },
    activeTabName(val) {
      LocalStorageUtils.setConfiguration('PriceWeightLimit', val)
    }
  },
  beforeMount() {
    this.init()
  },
  methods: {
    async init() {
      const activeTab = LocalStorageUtils.getConfiguration('PriceWeightLimit')
      this.activeTabName = !StrUtils.isEmpty(activeTab) ? activeTab : 'ppList'
      this.isHQManager = MultiCompanyUtil.getInstance().isHQManager('PriceFcl')
      this.priceFclUtil = await PricingFCLConfigUtil.getInstance()
      if (this.$store.getters.isAdmin) {
        this.approveAllowed_PP = true
        this.deleteAllowed_PP = true
        this.deleteAllowed_CP = true
        this.inputAllowed_PP = true
      } else {
        if (this.isHQManager) {
          this.deleteAllowed_PP = true
        }
        this.approveAllowed_PP = this.deleteAllowed_CP = this.priceFclUtil.isApprove
        this.inputAllowed_PP = this.priceFclUtil.isInput
      }
    },
    // tab 页签点击事件
    handleTabClick(tab, event) {
      this.activeTabName = tab.name
      if (tab.name === this.activeTabName && this.$refs[this.activeTabName]) {
        this.$refs[this.activeTabName].fetchOrderRequirement()
      }
    },
    toAdvancedQuery(data) {
      this.proxy = data
      this.toQuery()
    },
    // 查询
    toSimpleQuery(proxy) {
      this.proxy = proxy
      this.toQuery()
    },
    onWeightLimitFormDialogClose() {
      this.weightLimitFormDialog.visible = false
      this.weightLimitFormDialog.price = {}
    },
    toQuery() {
      this.fullscreenLoading = getLoading()
      if (this.activeTabName === 'cpList') {
        queryEffectivePriceWeightLimit(this.proxy).then((res) => {
          this.handleQueryData(res)
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      } else {
        queryPendingPriceWeightLimit(this.proxy).then((res) => {
          this.handleQueryData(res)
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      }
    },
    handleQueryData(res) {
      const result = res.data
      this.loadingEnd()
      if (!result || result.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        this.setRowData([])
        return
      }
      const count = result.length
      // 只返回部分结果的话，弹窗提醒是否加载更多
      let isMore = false
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
        this.$confirm(msg, this.$t('Pricing.Tips'), {
          confirmButtonText: this.$t('Pricing.YesLabel'),
          cancelButtonText: this.$t('Pricing.NoLabel'),
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }).then(() => {
        }).catch(() => {
          this.proxy.isLimited = false
          this.toAdvancedQuery(this.proxy)
          return
        })
        isMore = true
      }
      if (isMore) {
        result.pop()
      }
      this.setRowData(result)
    },
    setRowData(result) {
      if (this.isActiveCpTab) {
        this.rowCpData = result
      } else {
        this.rowPpData = result
      }
    },
    loadingEnd() {
      const api = this.getGridOptionsApi()
      api.clearFocusedCell()
      this.cpSelectRow = null
      this.ppSelectRow = null
      this.fullscreenLoading.close()
    },
    getGridOptionsApi() {
      return this.isActiveCpTab ? this.cpGridOptions.api : this.ppGridOptions.api
    },
    onRowDoubleClicked(e) {
      const data = e.data
      if (this.activeTabName === 'cpList') {
        this.cpSelectRow = data
        this.onEdit_CP()
      } else {
        this.ppSelectRow = data
        this.onEdit_PP()
      }
    },
    onEdit_CP() {
      this.edit(this.cpSelectRow)
    },
    onDelete_CP() {
      const selectedRows = this.getSelectedRowsCp()
      if (selectedRows === null) {
        return
      }
      this.$confirm(this.$t('Pricing.IsDeleteRecord'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        this.deleteCp(uuids)
      })
    },
    // 获取已发布的勾选数据
    getSelectedRowsCp() {
      const { api } = this.cpGridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      if (!this.isHQManager) {
        for (const item of selectedRows) {
          if (item.branchId !== this.$store.getters.currentOfficeId) {
            this.$message.warning(this.$t('Pricing.pleaseChooseOtherOfficeData'))
            return null
          }
        }
      }
      return selectedRows
    },
    // 获取待审核的勾选数据
    getSelectedRowsPp() {
      const { api } = this.ppGridOptions
      const selectedRows = api.getSelectedRows()
      if (selectedRows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return null
      }
      return selectedRows
    },
    // 修改已发布运价后, 移除原有记录
    deleteCp(data) {
      deletePriceWeightLimits(data).then(res => {
        this.$message.success(this.$t('Message.DeleteSuccessfully'))
        this.toQuery()
      }).finally(() => {
      })
    },
    onEdit_PP() {
      this.edit(this.ppSelectRow)
    },
    edit(selectRow) {
      if (!this.inputAllowed_PP) return
      if (!selectRow) {
        this.$message.warning(this.$t('Pricing.NoRecordSelect'))
        return
      }
      this.weightLimitFormDialog.visible = true
      this.weightLimitFormDialog.isNew = false
      this.weightLimitFormDialog.price = selectRow
    },
    onDelete_PP() {
      const selectedRows = this.getSelectedRowsPp()
      for (const item of selectedRows) {
        if (!(this.deleteAllowed_PP || item.createdBy === this.$store.getters.userInfo.userId)) {
          this.$message.warning(this.$t('Pricing.NotAllowedDelete'))
          return null
        }
      }
      if (selectedRows === null) {
        return
      }
      this.$confirm(this.$t('Pricing.IsDeleteRecords'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = this.getSelectUuids(selectedRows)
        deletePriceWeightLimits(uuids).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.toQuery()
        })
      })
    },
    getSelectUuids(selectedRows) {
      const uuids = []
      selectedRows.forEach(item => {
        uuids.push(item.uuid)
      })
      return uuids
    },
    // 审核
    onApprove_PP() {
      const selectedRows = this.getSelectedRowsPp()
      if (selectedRows === null) return
      this.$confirm(this.$t('Pricing.IsApproveRecords'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        approvePriceWeightLimits(selectedRows).then(res => {
          this.$message.success(this.$t('Message.AuditSuccessfully'))
          this.toQuery()
        })
      })
    },
    onAdd_PP() {
      this.weightLimitFormDialog.visible = true
      this.weightLimitFormDialog.isNew = true
      this.weightLimitFormDialog.price = {
        state: PriceConstant.PRICE_STATE_PENDING,
        currency: 'RMB',
        eqType: 'GP',
        eqSize: '20'
      }
    },
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('FCL_Weight_Limit_sample.xls', 'price')
    },
    selectRowChange(data) {
      if (this.activeTabName === 'cpList') {
        this.cpSelectRow = data
      } else {
        this.ppSelectRow = data
      }
    },
    uploadExcelSuccess(response, file, fileList) {
      if (response && response.data) {
        this.onImportSucceeded(JSON.parse(response.data))
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(message) {
      if (message.success) {
        const result = message.resultMessage
        if (result === '') {
          this.$message.error(this.$t('Pricing.NoRecordUpload'))
          return
        }
        const records = result.split(',')
        let msg = ''
        if (records.length > 1) {
          for (const sheet of records) {
            if (StrUtils.isEmpty(sheet)) {
              continue
            }
            const tmp = sheet.split(':')
            msg += StrUtils.substitute(this.$t('Pricing.Records'), tmp) + '\n'
          }
          msg += this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        } else {
          const tmp = result.split(':')
          msg = StrUtils.substitute(this.$t('Pricing.Records'), tmp)
          msg = msg.substr(0, msg.length - 1) + this.$t('Pricing.LoadSucceed')
          this.$message.success(msg)
        }
        return false
      }
      // 导入失败
      const failResult = PriceUploadExceptionUtil.handleError(message)
      const msg = {
        dangerouslyUseHTMLString: true,
        message: failResult.replace(/\n\t/g, '<br/>'),
        type: 'error',
        duration: 5000
      }
      this.$message.error(msg)
    }
  }
}
</script>

<style scoped>

</style>
